import { saveReceipt } from "./bridgeHandler";

export const downloadFileFromUrl = (fileUrl: string, fileName: string, base64?: string) => {
  if (base64) {
    const success = saveReceipt(base64, fileName);

    if (success) return;
  }

  const link = document.createElement("a");
  if (link.download !== undefined) {
    link.setAttribute("href", fileUrl);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
